import React, { useEffect, useState } from 'react';
import LayoutWithNavbar from './LayoutWithNavbar';
import { fetchStates, fetchMismatchedSummary } from '../services/api';
import { FaFileExcel } from 'react-icons/fa';
import * as XLSX from 'xlsx';

const MismatchedSummaryPage = () => {
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const [summaryData, setSummaryData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadStates = async () => {
      const res = await fetchStates();
      if (res.success) setStates(res.data);
    };
    loadStates();
  }, []);

  const handleSearch = async () => {
    if (!selectedState) return alert('Please select a state');
    setLoading(true);
    const res = await fetchMismatchedSummary(selectedState);
    if (res.success) {
      setSummaryData(res.data.vendor_mismatched_summary || []);
    } else {
      alert(res.message || 'Failed to fetch summary');
    }
    setLoading(false);
  };

  const handleRowClick = (gstid) => {
    // navigate(`/form2b-details/${gstid}?state=${selectedState}`);
    const url = `${window.location.origin}/vendor-mismatch/${gstid}?state=${selectedState}`;
    window.open(url, '_blank');
  };

  const handleExport = () => {
    if (summaryData.length === 0) {
      alert("No data to export.");
      return;
    }

    const sheetData = summaryData.map(row => ({
      'Vendor': row.vendor_name,
      'GSTIN': row.gstin,
      'Total Invoices': row.total_invoices,
      'Total Invoice Value': row.total_invoice_value,
      'Total Tax': row.total_tax_value
    }));

    const worksheet = XLSX.utils.json_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Mismatched Summary');
    XLSX.writeFile(workbook, `Mismatched_Summary_${selectedState}.xlsx`);

    

  };

  return (
    <LayoutWithNavbar>
      <div style={styles.container}>
        <h2 style={styles.heading}>Mismatched ITC & 2B Summary</h2>

        <div style={styles.filterSection}>
          <select value={selectedState} onChange={e => setSelectedState(e.target.value)} style={styles.select}>
            <option value=''>Select State</option>
            {states.map(s => <option key={s.id} value={s.statename}>{s.statename}</option>)}
          </select>
          <button onClick={handleSearch} style={styles.searchButton}>Search</button>
          <button onClick={handleExport} style={styles.exportButton}>
            <FaFileExcel style={{ marginRight: '8px' }} /> Export
          </button>
        </div>

        {loading ? (
          <div style={styles.loaderWrapper}>
            <div style={styles.spinner}></div>
            <p style={styles.loading}>Loading...</p>
          </div>
        ) : (
          <div style={styles.tableWrapper}>
            <table style={styles.table}>
              <thead>
                <tr>
                  {['Vendor', 'GSTIN', 'Total Invoices', 'Total Invoice Value', 'Total Tax'].map((col, i) => (
                    <th key={i} style={styles.th}>{col}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {summaryData.map((row, i) => (
                  <tr key={i} style={styles.tr}  onClick={() => handleRowClick(row.gstid)}>
                    <td style={styles.td}>{row.vendor_name}</td>
                    <td style={styles.td}>{row.gstin}</td>
                    <td style={styles.td}>{row.total_invoices}</td>
                    <td style={styles.td}>{row.total_invoice_value}</td>
                    <td style={styles.td}>{row.total_tax_value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </LayoutWithNavbar>
  );
};

const styles = {
  container: {
    padding: '30px',
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
    fontFamily: 'Segoe UI, sans-serif'
  },
  heading: {
    fontSize: '24px',
    fontWeight: '600',
    marginBottom: '20px'
  },
  filterSection: {
    display: 'flex',
    gap: '15px',
    marginBottom: '20px',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
    alignItems: 'center'
  },
  select: {
    padding: '12px',
    fontSize: '16px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    minWidth: '220px'
  },
  searchButton: {
    padding: '12px 20px',
    fontSize: '16px',
    fontWeight: '600',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer'
  },
  exportButton: {
    padding: '12px 20px',
    fontSize: '16px',
    fontWeight: '600',
    backgroundColor: '#28a745',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center'
  },
  tableWrapper: {
    overflowX: 'auto',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 0 10px rgba(0,0,0,0.04)'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    minWidth: '800px'
  },
  th: {
    padding: '12px',
    backgroundColor: '#343a40',
    color: '#fff',
    fontWeight: '500',
    textAlign: 'left',
    borderBottom: '1px solid #dee2e6'
  },
  tr: {
    cursor: 'pointer',
    transition: 'background 0.2s'
  },
  td: {
    padding: '12px',
    borderBottom: '1px solid #dee2e6',
    fontSize: '16px',
    backgroundColor: '#fff'
  },
  loaderWrapper: {
    textAlign: 'center',
    marginTop: '50px'
  },
  loading: {
    fontSize: '18px',
    fontWeight: '500',
    color: '#666',
    marginTop: '16px'
  }
};

export default MismatchedSummaryPage;
